export { isAbsoluteUrl, normalizeAssetUrl } from "@flint/build";